<template>
    <div class="itemBusca element-box">
        <div class="row">
            <div class="col-md-2 text-center">
                <div class="avatar-w">
                    <a href="#"  @click="goToSingleConsultorio(unidade)">
                      <img alt="" class="img-fluid"
                        :src="`${baseUrl}/redeImagemLogo?q=${unidade.nomeRede}`"
                        :onerror="`this.src='${require('@/img/icon-drachei-alpha.svg')}'`">
                      </a>

                </div>
                <rate :length="5" :value="unidade.rate" :disabled="true" ></rate>
            </div>
            <div class="col-md-10">
              <div class="row">
                <div class="col">
                  <a href="#"  @click="goToSingleConsultorio(unidade)"><h4>{{ unidade.nomeRede }}</h4></a>
                </div>
              </div>
              <div class="row">
                <div class="col-md-5">
                    <small>Valores</small>
                    <ul class="list-group">
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            <div class="d-flex w-80 justify-content-between">
                              <b>Dr.Achei Benefícios</b>
                            </div>
                            <div class="d-flex w-20 justify-content-end">
                              <div class="trending down">
                                <span>{{ porcentagemDesconto | money(porcentagem) }}</span><i class="os-icon os-icon-arrow-down"></i>
                              </div>
                              <span class="badge badge-success text-bold">{{ (valorSinsaude || 0.0) | money }}</span>
                            </div>
                        </li>
                        <li v-if="unidade.pagamentoOnline" class="list-group-item d-flex justify-content-between align-items-center">
                            Dr.Achei
                            <span class="badge badge-primary">{{ (valorDrAchei || 0.0) | money }}</span>
                        </li>
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                          <span>Particular</span>
                          <span class="badge badge-light">{{ (valorParticular || 0.0) | money }}</span>
                        </li>

                    </ul>
                </div>
                <div class="col-md-4">
                    <div class="row">
                      <div class="col">
                        <small>Descrição</small>
                        <p v-if="unidade.consultas" v-text="unidade.consultas.descricaoConsulta"></p>

                        <p v-if="unidade.exames" v-text="unidade.exames.nomeExame"></p>
                        <div class="features">
                            <a v-if="unidade.agendamento" href="#" class="badge badge-primary mr-sm-2">Agendamento</a>
                            <a v-if="unidade.delivery" href="#" class="badge badge-primary mr-sm-2">Em Domicílio</a>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="unidade.consultas">
                      <div class="col">
                        <small>Especialidade</small>
                        <p>{{especialidadeFormBusca}}</p>
                      </div>
                    </div>

                </div>

                <div class="col-md-3 text-right">
                    <button v-if="unidade.pagamentoOnline" class="mb-2 btn btn-success" type="button"
                      @click="goToSingleConsultorio(unidade)">
                        <i class="fa fa-shopping-cart"></i>
                        <span>Adquirir</span>
                    </button>
                    <button v-if="unidade.agendamento" class="mb-2 btn btn-primary" type="button"
                      @click="goToSingleConsultorio(unidade)">
                        <i class="os-icon os-icon-calendar-time"></i>
                        <span>Marcar Consulta</span>
                    </button>
                    <div class="dados">
                        <h6 v-if="unidade.telefone" class="mt-2 mb-2"><i class="ti-mobile"></i> {{ unidade.telefone }}</h6>
                        <a href="#" class="location"><i class="ti-location-pin"></i> <span>{{ endereco }}</span></a>
                    </div>
                    <!--<div class="social">
                        <a href="#"><i class="os-icon os-icon-twitter"></i></a>
                        <a href="#"><i class="os-icon os-icon-facebook"></i></a>
                        <a href="#"><i class="os-icon os-icon-instagram"></i></a>
                    </div>-->
                </div>
              </div>
            </div>

        </div>
    </div>
</template>
<script>
import ImagemRede from '@/components/shared/ImagemRede'
import http from 'axios'

export default {
  components: {
    ImagemRede
  },
  props: {
    unidade: {
      type: Object,
      required: true
    },
    servico: {
      type: String,
      required: true
    },
    especialidade: {
      type: Object
    }
  },
  data () {
    return {
      porcentagem: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: ' %',
        precision: 2,
        masked: true /* doesn't work with directive */
      }
    }
  },
  computed: {
    endereco () {
      let unidade = this.unidade
      return `${unidade.localAtendimento}, número ${unidade.numero}, ${unidade.bairro}, ${unidade.cidade} - ${unidade.uf}`
    },
    valorSinsaude () {
      return this.unidade.consultas ? this.unidade.consultas.valorSinSaude : this.unidade.exames ? this.unidade.exames.valorSinSaude : 0
    },
    valorDrAchei () {
      return this.unidade.consultas ? this.unidade.consultas.valorDrAchei : this.unidade.exames ? this.unidade.exames.valorDrAchei : 0
    },
    valorParticular () {
      return this.unidade.consultas ? this.unidade.consultas.valorParticular : this.unidade.exames ? this.unidade.exames.valorParticular : 0
    },
    baseUrl () {
      return http.defaults.baseURL
    },
    porcentagemDesconto () {
      return this.unidade.consultas ? Number(this.unidade.consultas.porcentagemDesconto) : 0
    },
    queryParam () {
      let params = {}
      params.servico = this.servico
      params.idRede = this.unidade._id
      if (this.especialidade) {
        params.especialidade = this.especialidade._id
      }
      if (this.$store.getters.formBusca.exame) {
        params.exames = []
        params.exames.push(this.$store.getters.formBusca.exame.codigoExame)
      }
      return params
    },
    especialidadeFormBusca () {
      return this.$store.getters.formBusca.especialidade.nome
    }
  },

  methods: {
    removeWhiteSpace (value) {
      return !value ? '' : value.replace(/\s+/g, '-')
    },
    goToSingleConsultorio (rede) {
      const query = {idRede: rede._id, servico: this.servico}
      query.rede = this.removeWhiteSpace(rede.nomeRede)
      query.cidade = this.removeWhiteSpace(rede.cidade)
      let preco = 0

      if (this.especialidade && this.servico === 'Consulta') {
        query.consulta = rede.consultas._id
        query.especialidade = this.especialidade._id
        query.nomeEspecialidade = this.removeWhiteSpace(this.especialidade.nome)
        preco = rede.consultas.valorSinSaude
      }
      if (this.$store.getters.formBusca.exame && this.servico === 'Exame') {
        query.exames = []
        query.exames.push(rede.exames._id)
        query.exame = this.removeWhiteSpace(rede.exames.nomeExame)
        preco = rede.exames.valorSinSaude
      }
      this.$router.push({name: 'Single',
        query,
        params: {
          nomeRede: this.removeWhiteSpace(rede.nomeRede),
          servico: this.servico,
          descricao: this.removeWhiteSpace(query.nomeEspecialidade || query.exame),
          cidade: this.removeWhiteSpace(rede.cidade),
          preco: preco ? preco.toFixed(2) : null
        }})
    }
  }
}
</script>
<style scoped>
.text-bold {
  font-weight: bold;
}
</style>




// WEBPACK FOOTER //
// src/components/busca/ItemConsultorio.vue